import { render, staticRenderFns } from "./genbyoutline4.vue?vue&type=template&id=4dbb4084&scoped=true"
import script from "./genbyoutline4.vue?vue&type=script&lang=js"
export * from "./genbyoutline4.vue?vue&type=script&lang=js"
import style0 from "./genbyoutline4.vue?vue&type=style&index=0&id=4dbb4084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb4084",
  null
  
)

export default component.exports